import apiClient, { ApiResponse, PaginatedResponse, PaginatedApiResponse } from '../api/client';
import { Customer } from '../types/models';

export interface CustomerFilters {
  search?: string;
  page?: number;
  per_page?: number;
  type?: 'individual' | 'business';
}

export interface CreateCustomerData {
  first_name: string;
  last_name: string;
  email?: string;
  phone: string;
  id_number?: string;
  address?: string;
}

export interface UpdateCustomerData extends Partial<CreateCustomerData> {}

class CustomerService {
  private baseUrl = '/admin/county/customers';

  // Get all customers
  async getCustomers(filters?: CustomerFilters): Promise<PaginatedApiResponse<any>> {
    const params = new URLSearchParams();
    if (filters?.search) params.append('search', filters.search);
    if (filters?.page) params.append('page', filters.page.toString());
    if (filters?.per_page) params.append('per_page', filters.per_page.toString());
    if (filters?.type) params.append('type', filters.type);

    return apiClient.get<any>(`${this.baseUrl}?${params.toString()}`) as Promise<PaginatedApiResponse<any>>;
  }

  // Get single customer
  async getCustomer(id: number): Promise<ApiResponse<Customer>> {
    return apiClient.get<Customer>(`${this.baseUrl}/${id}`);
  }

  // Get customer full details
  async getCustomerDetails(id: number): Promise<ApiResponse<any>> {
    return apiClient.get<any>(`${this.baseUrl}/${id}`);
  }

  // Toggle customer suspend status
  async toggleSuspend(id: number): Promise<ApiResponse<any>> {
    return apiClient.post<any>(`${this.baseUrl}/${id}/toggle-suspend`);
  }

  // Create customer
  async createCustomer(data: CreateCustomerData): Promise<ApiResponse<Customer>> {
    return apiClient.post<Customer>(this.baseUrl, data);
  }

  // Update customer
  async updateCustomer(id: number, data: UpdateCustomerData): Promise<ApiResponse<Customer>> {
    return apiClient.put<Customer>(`${this.baseUrl}/${id}`, data);
  }

  // Delete customer
  async deleteCustomer(id: number): Promise<ApiResponse> {
    return apiClient.delete(`${this.baseUrl}/${id}`);
  }

  // Search customers
  async searchCustomers(query: string): Promise<ApiResponse<Customer[]>> {
    return apiClient.get<Customer[]>(`${this.baseUrl}/search?q=${query}`);
  }
}

export const customerService = new CustomerService();
export default customerService;
